import { i18n } from 'i18next';

export const reloadInterpolations = (instances: i18n[]) => (organisationType?: string) => {
	instances.forEach((instance) => {
		instance.options.interpolation = {
			...(instance.options?.interpolation || {}),
			/**
			 * From i18next v21, the default for `skipOnVariables` is true.
			 * Setting this to false is needed to use interpolation variables with the `$t` function.
			 * They suggest to keep this option to true if interpolation variables
			 * are user provided or loaded from an external source.
			 * @see {@link https://www.i18next.com/translation-function/interpolation#all-interpolation-options}
			 */
			skipOnVariables: false,
			defaultVariables: getInterpolationsByOrgType(organisationType),
		};
	});
};

const getInterpolationsByOrgType = (orgType = 'default') => {
	const type = orgType?.toLowerCase() || 'default';

	return {
		caregivers: `$t(org-interpolations.${type}.caregivers)`,
		caregiver: `$t(org-interpolations.${type}.caregiver)`,
		'care-recipients': `$t(org-interpolations.${type}.care-recipients)`,
		'care-recipient': `$t(org-interpolations.${type}.care-recipient)`,
	};
};
